import { CubeSaveGenericServicesV2 } from "./api-connector";

class LocationServices extends CubeSaveGenericServicesV2 {
	getItem(itemID, partnerID = undefined) {
		return super.getItem(itemID, {
			batch: true,
			query: partnerID ? {partnerID} : undefined,
		});
	}

	getPartners(locationID) {
		return this.sendRequest({
			url: `/${locationID}/partner/`,
		});
	}
}

class PartnerServices extends CubeSaveGenericServicesV2 {
	getUsers(partnerID) {
		return this.sendRequest({
			url: `/${partnerID}/user/`,
		});
	}
}

export const locationServices = new LocationServices(`/location`);
export const locationPartnerServices = (locationID) => new PartnerServices(`${locationServices.url}/${locationID}/partner`);
